<pulse-field>
    <div
        #fieldBox
        class="pulse-multiselect__field"
        [class.pulse-multiselect__field--open]="expanded()"
        [class.pulse-multiselect__field--invalid]="invalid()"
        [class.pulse-multiselect__field--disabled]="isDisabled()"
        tabindex="-1"
        (click)="openField($event)"
    >
        <input
            #fieldEl
            ngComboboxInput
            pulsePopupInput
            class="pulse-multiselect__value"
            type="text"
            readonly
            (blur)="markTouched()"
        />
        @if (clearable() && count() > 0 && !isDisabled()) {
            <button
                type="button"
                class="pulse-multiselect__clear"
                [attr.aria-label]="clearLabel() || null"
                (click)="clear($event)"
                (keydown)="keepKey($event)"
            ></button>
        }
        <span class="pulse-multiselect__chevron" aria-hidden="true"></span>
    </div>
</pulse-field>

<div
    #panel
    popover="manual"
    class="pulse-multiselect__panel"
    [hidden]="!expanded()"
    [style.top.px]="anchor()?.top"
    [style.left.px]="anchor()?.left"
    [style.width.px]="anchor()?.width"
>
    <div class="pulse-multiselect__toolbar">
        @if (searchable()) {
            <input
                class="pulse-multiselect__search"
                type="text"
                [value]="searchText()"
                [placeholder]="'PulseMultiselect.Search' | translate"
                [attr.aria-label]="'PulseMultiselect.Search' | translate"
                [attr.aria-controls]="popupId()"
                [attr.aria-activedescendant]="activeOptionId()"
                (input)="onSearch($event)"
                (keydown.space)="$event.stopPropagation()"
            />
        }
        <button
            type="button"
            class="pulse-multiselect__action"
            (click)="toggleAll()"
            (keydown)="keepKey($event)"
        >
            {{
                (count() > 0 ? 'PulseMultiselect.ClearAll' : 'PulseMultiselect.SelectAll')
                    | translate
            }}
        </button>
    </div>
    <ng-content />
</div>
